var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CrudTable',{attrs:{"storeModule":_vm.storeModule,"headers":_vm.headers,"addItems":false},on:{"save":_vm.onTopicEdition},scopedSlots:_vm._u([{key:"form",fn:function(ref){
var close = ref.close;
return [_c('ProductBrandForm',{attrs:{"showHeader":""},on:{"save":_vm.afterCreation,"close":close}})]}},{key:"item.external_id",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'ProductBrandDetail', params: { id: item.external_id }}}},[_vm._v(" "+_vm._s(item.external_id)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }